import {
  DropdownPosition,
  DropdownAlignment,
} from "../../Utility/Dropdown/Dropdown.interface";

export default function calcTooltipPos({
  currentPosition,
  currentAlignment,
}: {
  currentPosition: DropdownPosition;
  currentAlignment: DropdownAlignment;
}): string {
  let tooltipPos: string = DropdownPosition.BOTTOM;
  if (
    [DropdownPosition.LEFT, DropdownPosition.RIGHT].includes(currentPosition)
  ) {
    tooltipPos = currentPosition;
  } else if (
    [DropdownPosition.TOP, DropdownPosition.BOTTOM].includes(currentPosition)
  ) {
    if (
      [DropdownAlignment.START, DropdownAlignment.END].includes(
        currentAlignment,
      )
    ) {
      tooltipPos = `${currentPosition}-${currentAlignment}`;
    } else {
      tooltipPos = currentPosition;
    }
  }

  return tooltipPos;
}
